import { Link } from 'react-router-dom';
import { mainSiteUrl, categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200 pt-14 md:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-lg font-heading font-bold text-foreground-900">
                Sugargoo<span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              The ultimate Sugargoo Spreadsheet resource platform — organizing product discoveries, shipping guides, and shopping intelligence for smarter international purchasing.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-xs font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Shopping Guides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Complete Guide</Link>
              </li>
              <li>
                <Link to="/sugargoo-shipping-cost" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Shipping Cost</Link>
              </li>
              <li>
                <Link to="/is-sugargoo-legit" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Is Sugargoo Legit</Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Coupon & Discount</Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Warehouse Guide</Link>
              </li>
              <li>
                <Link to="/sugargoo-vs-competitors" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">vs Competitors</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Home</Link>
              </li>
              <li>
                <Link to="/sugargoo-best-finds" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Best Finds</Link>
              </li>
              <li>
                <Link to="/sugargoo-beginner-tutorial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Beginner Tutorial</Link>
              </li>
              <li>
                <Link to="/sugargoo-save-money" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">Save Money Tips</Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} SugargooSheet. This website provides educational information and resources. Users should verify external services before making purchasing decisions.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">Home</Link>
            <Link to="/sugargoo-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">Guide</Link>
            <Link to="/sugargoo-shipping-cost" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">Shipping</Link>
            <Link to="/is-sugargoo-legit" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">Safety</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}